import { useMergedRef as useMergedRefMantine } from '@mantine/hooks';

export const useMergedRef = useMergedRefMantine;
